import { Link, Paragraph } from '@vimeo/iris/typography';

export default function Portfolios() {
  return (
    <div>
      <Paragraph size="2">
        <em>Portfolios</em> are customizable websites for showcasing videos. Vimeo Standard and
        Advanced subscribers have access to this feature. For more information, see our{' '}
        <Link
          variant="minimal"
          href="https://help.vimeo.com/hc/en-us/articles/12426231778577-Portfolios"
        >
          Help Center
        </Link>
        .
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
